import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../scss/Footer.scss";
import ticket from "../assets/footer/Ticket.png";
import trustpilot from "../assets/footer/trustpilot.svg";
import rating from "../assets/footer/rating.svg";
import location from "../assets/footer/location.svg";
import email from "../assets/footer/email.svg";
import phone from "../assets/footer/phone.svg";
import website from "../assets/footer/website.svg";
import linkedIn from "../assets/footer/linkedin.svg";
import { motion } from "framer-motion";

const Footer = () => {
    const navigate = useNavigate();
    return (
        <footer className="flex flex-col items-center self-stretch mt-[10px] md:mt-[0px] pt-4 w-full text-white bg-dark-indigo max-md:mt-10 max-md:max-w-full">
            <motion.div className="bg-[#363882] h-[120px] relative z-12 mt-[-60px] w-full sm:w-[748px] px-3 sm:px-4"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                viewport={{ once: true }}

                style={{ background: `url(${ticket}) no-repeat center`, backgroundSize: 'fill' }}>
                <div className="flex items-center justify-between w-full relative z-12">
                    <h3 className="font-semibold text-[24px] leading-[24px] sm:text-[32px] sm:leading-[32px] mt-[16px] text-white">
                        Enhance <span className="font-light text-[18px]">Your</span> Strategy <br /> <span className="font-light text-[18px]">With</span> Valuable <span className="font-light">Insights</span>
                    </h3>
                    <button className="justify-center items-center self-center px-4 py-3 my-8 max-w-full text-xl sm:text-2xl font-light text-center dark-button text-white whitespace-nowrap rounded-lg  shadow-xl w-[178px] sm:w-[220px] max-md:px-5"
                        onClick={() => navigate("/clients")}>
                        Become A Client
                    </button>
                </div>
            </motion.div>

            <motion.div className="details"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                viewport={{ once: true }}>

                <div className="flex gap-5 items-start justify-center mt-2 max-w-full text-center sm:w-[755px] max-md:flex-wrap">
                    <div className="flex gap-2 text-md sm:text-3xl font-medium whitespace-nowrap">
                        <img
                            alt="Trustpilot Logo"
                            src={trustpilot}
                            className="shrink-0 aspect-[1.05] fill-emerald-400 w-[20px] sm:w-[37px]"
                        />
                        <span className="flex-auto mt-3">Trustpilot</span>
                    </div>
                    <div className="flex flex-auto gap-5 mt-1.5 text-md sm:text-xl">
                        <img
                            alt="Trustpilot Rating"
                            src={rating}
                            className="shrink-0 max-w-full aspect-[5.88] w-[120px] sm:w-[212px]"
                        />
                        <span className="flex-auto self-start mt-2.5">
                            Trust Score{" "}
                            <span className="sm:text-2xl font-medium text-emerald-400">4.5</span> |{" "}
                            <span className="sm:text-2xl font-medium">300</span> reviews
                        </span>
                    </div>
                </div>
                <h2 className="mt-10 sm:text-xl font-medium text-center w-full max-md:max-w-full md:w-[755px]">
                    <span className="uppercase">Expertefy</span> - Your Trusted Partner for
                    Expert Insights
                    <br />
                    <span>
                        Connecting you to top-tier professionals across diverse industries.
                    </span>
                </h2>
                <div className="flex pl-3 sm:pl-0 gap-2 mt-7 text-sm sm:text-lg font-medium">
                    <img
                        alt="Location Icon"
                        src={location}
                        className="shrink-0 w-5 sm:w-6 aspect-square"
                    />
                    <div className="flex-auto max-md:max-w-full">
                        12 Swan Close, Washwood Heath Birmingham, B8 2XN United Kingdom
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row space-x-3 sm:space-x-0 gap-5 justify-between mt-6 max-w-full text-sm sm:text-lg font-medium whitespace-nowrap w-full sm:w-[715px] max-md:flex-wrap">
                    <a href="mailto:info@expertefy.com" className="flex gap-2 pl-3 sm:pl-0">
                        <img
                            alt="Email Icon"
                            src={email}
                            className="shrink-0 w-5 sm:w-6 aspect-square"
                        />
                        <span className="flex-auto underline">info@expertefy.com</span>
                    </a>
                    <a href="tel:+447360266340" className="flex gap-2">
                        <img
                            alt="Phone Icon"
                            src={phone}
                            className="shrink-0 w-5 sm:w-6 aspect-square"
                        />
                        <span className="flex-auto">+447360266340</span>
                    </a>
                    <a href="https://expertefy.com" className="flex gap-2">
                        <img
                            alt="Website Icon"
                            src={website}
                            className="shrink-0 w-5 sm:w-6 aspect-square"
                        />
                        <span className="flex-auto underline">expertefy.com</span>
                    </a>
                    <a href="https://www.linkedin.com/company/expertefy/" target="_blank" rel="noreferrer" className="flex gap-2">
                        <img
                            alt="LinkedIn Icon"
                            src={linkedIn}
                            className="shrink-0 w-5 sm:w-6 aspect-square"
                        />
                    </a>
                </div>
            </motion.div>
            <div className="flex justify-center items-center self-stretch px-16 py-4 mt-4 w-full text-lg font-light max-md:px-5 max-md:max-w-full bg-light-indigo">
                <span className="flex gap-2.5">
                    <span className="text-center">
                        <strong>Copyright</strong>
                    </span>
                    &copy;
                    <span className="flex-auto">
                        <strong>2024 expertefy.com</strong>
                    </span>
                </span>
            </div>
        </footer>
    );
};

export default Footer;
